import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import DreamBrokerLogoWhiteSimple from "@components/WebsiteRevamp/icons/DreamBrokerLogoWhiteSimple"
import React from "react"

import styles from "./PrivateHeader.module.scss"
type Props = {}

const PrivateHeader = (props: Props) => {
	return (
		<>
			<header className={`${styles.header} ${styles.show} `}>
				<div
					style={{
						height: "100%",
					}}
				>
					<ContainerWrapper
						style={{
							height: "100%",
						}}
					>
						<div className={styles.headerContainer}>
							<div className={styles.navBox}>
								<div className={styles.logoWrapper}>
									<div className={styles.logoBox}>
										{/* <DreamBrokerLogoWhiteSimple
											className={styles.logo}
										/>
										<Typography
											fontWeight={700}
											size={Size.XS}
											className={styles.companyTitle}
											style={{
												textTransform: "uppercase",
												letterSpacing: "3px",
											}}
											variant={Variant.Description}
											contrast
											noPadding
										>
											DREAMBROKER
										</Typography> */}
										<div
											className={
												styles.companyTitleWrapper
											}
										>
											<DreamBrokerLogoWhiteSimple
												className={styles.logo}
											/>
											<span
												className={
													styles.companyTitleOne
												}
											>
												One
											</span>
										</div>
										<span
											className={
												styles.companyTitleCommunications
											}
										>
											Communications
										</span>
									</div>
									<Typography
										fontWeight={300}
										size={Size.XS}
										style={{
											textTransform: "uppercase",
										}}
										variant={Variant.Description}
										contrast
										noPadding
									>
										Communication Software Company
									</Typography>
								</div>
							</div>
						</div>
					</ContainerWrapper>
				</div>
			</header>
		</>
	)
}

export default PrivateHeader
